import React, { useState, useEffect } from 'react';
import i18n from 'i18next';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { config } from '../config';
import { handleResponse } from '../helpers/response';
import Footer from './footer';
import { Helmet } from 'react-helmet';

const CategoriesList = (props) => {
  const category = props.match.params.category;

  const [subCategories, setSubCategories] = useState([]);
  const [isShowLoader, setIsShowLoader] = useState(true);
  useEffect(() => {
    const link = config.apiUrl + 'api/get/subcategories/list/' + category;
    fetch(link, { method: 'GET' })
      .then(handleResponse)
      .then((json) => {
        setSubCategories(json);
        setIsShowLoader(false);
      })
      .catch((error) => {});
  }, [category]);

  return (
    <>
      <Helmet>
        <header>
          <meta charSet='utf-8' />
          <title>
            {isShowLoader === false &&
              subCategories['parent']['name_' + i18n.language]}
          </title>
        </header>
      </Helmet>
      <div className='main-container uk-container  uk-flex uk-flex-wrap uk-flex-top'>
        <div className='uk-margin-top uk-width-1-1'>
          <h1 className='page-title uk-text-bold'>
            {isShowLoader === false &&
              subCategories['parent']['name_' + i18n.language]}
          </h1>
        </div>

        <div
          className='uk-child-width-1-4@l uk-child-width-1-3@m uk-child-width-1-2 uk-grid-match uk-grid-small uk-margin-top uk-width-1-1'
          uk-grid=''
        >
          {isShowLoader == false &&
            Object.keys(subCategories['subcategories']).map((inx) => {
              const isCategoryLink =
                subCategories['subWithChild'][inx] !== undefined ? '/list' : '';
              const item = subCategories['subcategories'][inx];
              const link = `/products/${
                i18n.language + '/' + item['alias'] + isCategoryLink
              }`;
              const image =
                config.assetsPrfix + 'img/products/min_' + item['icon'];
              const noImage =
                config.assetsPrfix + 'img/categories/logo/no_image.png';
              return (
                <>
                  <div>
                    <div className='category-card uk-card uk-card-small'>
                      <div className='uk-card-media-top uk-text-center uk-padding-small'>
                        <Link to={link}>
                          <img
                            className='category-card__image uk-height-small'
                            src={item['icon'] ? image : noImage}
                            alt={item[`name_${i18n.language}`]}
                          />
                        </Link>
                      </div>
                      <div className='uk-card-body'>
                        <Link
                          className='category-card__name'
                          to={link}
                          title={item[`name_${i18n.language}`]}
                        >
                          <h3>{item[`name_${i18n.language}`]}</h3>
                        </Link>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CategoriesList;
